import { useState } from 'react';
import CaretDownIcon from '../icons/CaretDownIcon';
import CaretUpIcon from '../icons/CaretUpIcon';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { selectLang } from '../../../store/ui/ui.selector';
import { translate } from '../../../lib/lang.helper';
import Input from './Input';
const { Option }: any = Select;

interface IOption {
  id: string;
  value: string | undefined;
  label: string;
}

interface Props {
  className?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  options: IOption[];
  onChange?: (value: string | undefined) => void;
  disabled?: boolean;
}

const CustomSelect = ({
  className,
  label,
  placeholder,
  value,
  options,
  onChange,
  disabled,
}: Props) => {
  const lang = useSelector(selectLang);

  const [open, setOpen] = useState(false);

  const suffixIcon = (
    <div className='dropdown__icon dropdown__icon--rotate-180'>
      {open ? <CaretDownIcon /> : <CaretUpIcon />}
    </div>
  );

  const handleChange = (val: string | undefined) => {
    if (!onChange) return;
    if (val === '__other') {
      onChange('');
    } else {
      onChange(val);
    }
  };

  return (
    <div className={className}>
      <label className='dropdown__label' htmlFor='dropdown'>
        {label}
      </label>
      <Select
        size='large'
        open={open}
        disabled={disabled}
        suffixIcon={suffixIcon}
        placeholder={placeholder}
        value={
          value === undefined || options.some(x => x.value === value)
            ? value
            : '__other'
        }
        onDropdownVisibleChange={o => setOpen(o)}
        onChange={handleChange}
        filterOption={(inputValue, option) =>
          option?.children.toLowerCase().includes(inputValue.toLowerCase())
        }
      >
        {options &&
          options.map(option => (
            <Option value={option.value} key={option.id}>
              {option.label}
            </Option>
          ))}
        <Option value={'__other'}>{translate(lang, 'Other')}</Option>
      </Select>
      {value !== undefined &&
        value !== null &&
        options.every(x => x.value !== value) && (
          <Input
            label=''
            type='text'
            value={value}
            onChange={e => onChange && onChange(e.target.value)}
          />
        )}
    </div>
  );
};

export default CustomSelect;
